import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { GlobalStyle } from './styles/GlobalStyle';
import ScrollToTop from './components/ScrollToTop';
import Header from './components/Header';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import ArticlePage from './pages/ArticlePage';
import AboutPage from './pages/AboutPage';
import PrivacyPage from './pages/PrivacyPage';
import TermsPage from './pages/TermsPage';
import AnalyticsHub from './pages/AnalyticsHub';

function AppContent() {
  const location = useLocation();
  const hideNavigation = location.pathname === '/analytics-hub';

  return (
    <div className="App">
      {!hideNavigation && <Header />}
      <main>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/article/:id" element={<ArticlePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/analytics-hub" element={<AnalyticsHub />} />
        </Routes>
      </main>
      {!hideNavigation && <Footer />}
    </div>
  );
}

function App() {
  return (
    <Router>
      <GlobalStyle />
      <ScrollToTop />
      <AppContent />
    </Router>
  );
}

export default App;